let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4kRJz")).then(() => parcelRequire('6VVS2'));